module.exports = __webpack_public_path__ + "static/img/1960_02_4_SaturdayReview_AlbumReview_2.65bb8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1960_02_4_SaturdayReview_AlbumReview_2.jpg
// module id = UW03
// module chunks = 0